import React from 'react';

type ProductInitErrorProps = {
    onRetry: () => void;
};

/** Fallback when product init fails. Must not read product store data. */
const ProductInitError = ({onRetry}: ProductInitErrorProps) => (
    <div
        role="alert"
        className="text-center w-100 p-4"
    >
        <h2>Sorry, this product could not be displayed at this time.</h2>
        <p>Please try again later.</p>
        <button
            type="button"
            className="btn btn-primary"
            onClick={onRetry}
        >
            Try again
        </button>
    </div>
);

export default ProductInitError;
